
import TableList from "@components/templates/tablelist";
import { HttpGetCustomShipDetail } from "@/service/billing";
import { HttpGetbillPeriodList } from "@/service/newbigaccount";
import { mapGetters } from "vuex";

import mixin from '../../minxin'

export default {
    mixins: [TableList,mixin],
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                search: {
                }
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
            peroList:[],
        };
    },
    created(){
        HttpGetbillPeriodList({
            page:1,
            rows:10000,
        }).then(res=>{
            this.peroList = res.data.content
        })
    },
    methods: {
        ajaxRequest: HttpGetCustomShipDetail,
        interceptRequest(params) {
            const { EQ_billingDate } = params.search;
            params.search.LE_startTime = EQ_billingDate;
            params.search.GE_endTime = EQ_billingDate;
            delete params.search.EQ_billingDate;
            this.formData = params
            return params
        },
        handleOperates(params = "", type, batch) {

            switch (type) {
                case 'export':
                    // this.handleWebfs(process.env.VUE_APP_APIURL_FBB + '/api/v2/freightSettlement/exportByManage', this.formData, {
                    //     executor: 'request',
                    //     download: true,
                    //     method: 'post',
                    // })

                    let urls = `https://${global.envPrefix}bi.onepinnovate.com/home/report/board?args={"__orgId__":"${this.formData.search.EQ_orgId || []}","billing_no":"${this.formData.search.EQ_billNo || []}","id":261}`

                    window.open(this.handleHostname(urls))
                    break;
            }
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getBillcusWareList', 'getCusproductList', 'getNextOrgList']),
        ToolsData() {
            return [
                {
                    name: this.$t('global.common.export',{defaultValue:'导出'}),
                    operate: "export",
                    theme: "info",
                    // batch: true,
                },
            ]
        },
        SearchsData() {
            let widthStyle = 'width: 200px;'
            return [
                // {
                //     label: this.$t('',{defaultValue:'客户组织'}),
                //     tag: 'vSelect',
                //     key: 'EQ_orgId',
                //     options:this.getNextOrgList,
                //     show: true,
                //     props:{
                //         filterable:true,
                //         clearable:true,
                //     }
                // },
                {
                    label: this.$t('fbb.billmanage.bill_no',{defaultValue:'账单编号'}),
                    tag: 'vInput',
                    key: 'EQ_billNo',
                    show: true,
                    style: widthStyle,
                },
                {
                    label: this.$t('fbb.billDelivery.trackingNo',{defaultValue:'运单号码'}),
                    tag: 'vInput',
                    key: 'EQ_trackingNo',
                    show: true,
                    style: widthStyle,
                },
                {
                    label:this.$t('fbb.billmanage.task_no',{defaultValue:'导入任务编号'}),
                    tag:'vInput',
                    key:'EQ_taskNo',
                    style: widthStyle,
                    show: true,
                },
                {
                    label: this.$t('fbb.billDelivery.sourceNo',{defaultValue:'关联单号'}),
                    tag: 'vInput',
                    key: 'EQ_sourceNo',
                    style: widthStyle,
                },
                {
                    label: this.$t('erp.b2border.payment_days',{defaultValue:'账期'}),
                    tag: 'vSelect',
                    key: 'EQ_periodId',
                    options: this.peroList.map(item=>{
                        return {
                            label:item.code,
                            value:item.id
                        }
                    }),
                    props:{
                        filterable:true,
                    },
                    style: widthStyle,
                },
                {
                    label: this.$t('global.common.createdtime',{defaultValue:'创建时间'}),
                    tag: 'vDatepicker',
                    key: 'BT_createdAt',
                    default: this.handleDateRange().join(' ~ '),
                    props: {
                        options: this.options,
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm: false,
                    },
                    style: widthStyle,
                },
            ]
        },
        columns() {
            return [
                // {
                //     title: this.$t('global.common.cusorg',{defaultValue:'客户组织'}),
                //     key: 'orgId',
                //     render: (h, { row }) => this.findRenderLabel(this.getNextOrgList, row.orgId)
                // },
                {
                    title: this.$t('fbb.billmanage.bill_no',{defaultValue:'账单编号'}),
                    key: 'billNo',
                },
                {
                    title: this.$t('fbb.billDelivery.trackingNo',{defaultValue:'运单号码'}),
                    key: 'trackingNo',
                },
                {
                    title: this.$t('fbb.billmanage.task_no',{defaultValue:'导入任务编号'}),
                    key: 'taskNo',
                },
                {
                    title: this.$t('erp.b2border.payment_days',{defaultValue:'账期'}),
                    render: (h,{row})=>{
                        return <div>
                            <div v-show={row.periodCode}>{row.periodCode} ({row.startTime} ~ {row.endTime})</div>
                            <div v-show={!row.periodCode}>--</div>
                        </div>
                    }
                },
                {
                    title: this.$t('fbb.billDelivery.costName',{defaultValue:'收费项'}),
                    key: 'costName',
                },
                {
                    title: this.$t('fbb.billDelivery.cost',{defaultValue:'收费金额(USD)'}),
                    key: 'cost',
                },
                {
                    title: this.$t('fbb.billDelivery.sourceNo',{defaultValue:'关联单号'}),
                    key: 'sourceNo',
                },
                {
                    title: this.$t('global.common.createdtime',{defaultValue:'创建时间'}),
                    key: 'createdAt',
                },
            ];
        },

    },

};
